<template>
  <div class="container">
    <div v-if="personInfo" class="box-card">
      <el-card class="header card" shadow="always">
        <el-row :gutter="12">
          <el-col class="grid-content" :span="2">
            <img class="avatar" :src="personInfo.logo" />
          </el-col>
          <el-col class="grid-content" :span="4">
            <span class="label">姓名：</span>
            <span class="content">{{ personInfo.name || "暂未授权" }}</span>
          </el-col>
          <el-col class="grid-content" :span="4">
            <span class="label">客户编号：</span>
            <span class="content">{{ personInfo.wid }}</span>
          </el-col>
          <el-col class="grid-content" :span="4">
            <span class="label">成为客户时间：</span>
            <span class="content">{{ personInfo.gmtCreate | formatDate }}</span>
          </el-col>
          <el-col class="grid-content" :span="4">
            <span class="label">性别：</span>
            <span class="content">{{
              personInfo.sex === 1 ? "男" : "女"
            }}</span>
          </el-col>
          <el-col class="grid-content" :span="4">
            <span class="label">手机号：</span>
            <span class="content">{{ personInfo.phone || "暂未授权" }}</span>
          </el-col>
          <el-col class="grid-content" :span="4">
            <span class="label">生日：</span>
            <span class="content">{{ personInfo.birthday || "暂未授权" }}</span>
          </el-col>
          <el-col class="grid-content" :span="4">
            <span class="label">身份证号：</span>
            <span class="content">{{ personInfo.idCard || "暂未授权" }}</span>
          </el-col>
          <el-col class="grid-content" :span="4">
            <span class="label">邮箱：</span>
            <span class="content">{{ personInfo.mail || "暂未授权" }}</span>
          </el-col>
          <el-col class="grid-content" :span="4">
            <span class="label">教育背景：</span>
            <span class="content">{{
              personInfo.education || "暂未授权"
            }}</span>
          </el-col>
          <el-col class="grid-content" :span="4">
            <span class="label">爱好：</span>
            <span class="content">{{ personInfo.hobby || "暂未授权" }}</span>
          </el-col>
          <el-col class="grid-content" :span="4">
            <span class="label">行业：</span>
            <span class="content">{{ personInfo.industry || "暂未授权" }}</span>
          </el-col>
          <el-col class="grid-content" :span="4">
            <span class="label">收入：</span>
            <span class="content">{{ personInfo.income || "暂未授权" }}</span>
          </el-col>
          <el-col class="grid-content" :span="4">
            <span class="label">地址：</span>
            <span class="content">{{ personInfo.address || "暂未授权" }}</span>
          </el-col>
        </el-row>
      </el-card>
      <el-card class="card" shadow="always">
        <span class="label">标签：</span>
        <el-tag
          v-for="item of personInfo.tagList"
          class="tags"
          effect="plain"
          
          :key="item.tagId"
          >{{ item.tagName }}</el-tag
        >
      </el-card>
      <el-card class="card" shadow="always">
        <el-row :gutter="12">
          <el-col :span="24" class="grid-content">
            <h3>会员</h3>
          </el-col>
          <el-col :span="4" class="grid-content">
            <span class="label">会员等级：</span>
            <span class="content">{{ personInfo.rankName || "暂无" }}</span>
          </el-col>
          <el-col :span="4" class="grid-content">
            <span class="label">会员卡号：</span>
            <span class="content">{{ personInfo.code }}</span>
          </el-col>
          <el-col :span="4" class="grid-content">
            <span class="label">会员状态：</span>
            <span class="content">
              <template v-if="personInfo.status === 1">正常</template>
              <template v-if="personInfo.status === 2">冻结</template>
              <template v-if="personInfo.status === 3">未领取</template>
              <template v-if="personInfo.status === 5">过期</template>
            </span>
          </el-col>
          <el-col :span="4" class="grid-content">
            <span class="label">领卡时间：</span>
            <span class="content">{{
              personInfo.cardPublishTime | formatDate
            }}</span>
          </el-col>
        </el-row>
      </el-card>
      <el-card class="card" shadow="always">
        <el-row :gutter="12">
          <el-col :span="24" class="grid-content">
            <h3>账户资产</h3>
          </el-col>

          <el-col :span="6" class="grid-content">
            <span class="label">当前余额：</span>
            <span class="content">{{ personInfo.currentAmount }}</span>
          </el-col>
          <el-col :span="6" class="grid-content">
            <span class="label">可用实充余额：</span>
            <span class="content">{{ personInfo.availableDepositAmount }}</span>
          </el-col>
          <el-col :span="6" class="grid-content">
            <span class="label">可用赠送余额：</span>
            <span class="content">{{ personInfo.availableGiveAmount }}</span>
          </el-col>
          <el-col :span="6" class="grid-content">
            <span class="label">当前成长值：</span>
            <span class="content">{{ personInfo.currentGrowth }}</span>
          </el-col>
          <el-col :span="6" class="grid-content">
            <span class="label">当前积分：</span>
            <span class="content">{{ personInfo.currentPoint }}</span>
          </el-col>
          <el-col :span="6" class="grid-content">
            <span class="label">累计积分：</span>
            <span class="content">{{ personInfo.totalPoint }}</span>
          </el-col>
          <el-col :span="6" class="grid-content">
            <span class="label">客单价：</span>
            <span class="content">{{
              personInfo.avgOrderConsumeAmount || 0
            }}</span>
          </el-col>
          <el-col :span="6" class="grid-content"></el-col>
          <el-col :span="6" class="grid-content">
            <span class="label">交易次数：</span>
            <span class="content">{{ personInfo.orderConsumeCount || 0 }}</span>
          </el-col>
          <el-col :span="6" class="grid-content">
            <span class="label">累积交易金额：</span>
            <span class="content">{{
              personInfo.orderConsumeAmount || 0 + "元"
            }}</span>
          </el-col>

          <el-col :span="6" class="grid-content">
            <span class="label">上次交易时间：</span>
            <template v-if="personInfo.lastTradeTime">
              <span class="content">{{
                personInfo.lastTradeTime | formatDate
              }}</span>
            </template>
            <template v-else>
              <span class="content">暂无</span>
            </template>
          </el-col>
        </el-row>
      </el-card>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import qs from "qs";
export default {
  name: "customerDetail",
  data() {
    return {
      personInfo: null,
    };
  },
  mounted() {
    if (window.localStorage.getItem("storuser")) {
      let userinfo = JSON.parse(window.localStorage.getItem("storuser"));
      this.tooken = userinfo;
    }
    this.cheshi();
    this.getData();
  },
  methods: {
    getData() {},
    cheshi() {
      this.axios
        .post(
          "/weimob/index/check_secret",
          qs.stringify({
            phone: this.tooken.phone,
              account_id: this.tooken.account_id,
          }),
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        )
        .then((res) => {
          if (res.data.code == 0) {
            this.$router.push("/register/user/paramBinbing");
          }
          if (res.data.code == 1) {
            this.axios
              .post(
                "/weimob/index/get_access_token",
                qs.stringify({
                  phone: this.tooken.phone,
              account_id: this.tooken.account_id,
                }),
                {
                  headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                  },
                }
              )
              .then((res) => {
                if (res.data.code == 1) {
                  this.accesstoken = res.data.data;
                  this.userTable();
                }
                if (res.data.code == 0) {
                  this.$router.push("/register/user/paramBinbing");
                }
              })
              .catch(function (err) {});
          }
        })
        .catch(function (err) {});
    },
    userTable() {
      this.axios
        .post(
          "/weimob/index/http_send",
          qs.stringify({
            type: 0,
              account_id: this.tooken.account_id,
            wid: this.$route.query.id,
            queryPisNeedTagsInfoarameter: true,
            isNeedExtInfo: true,
            accesstoken:
              "https://dopen.weimob.com/api/1_0/mc/member/getMemberDetail?accesstoken=" +
              this.accesstoken,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          this.personInfo = res.data.data;
        })
        .catch(function (err) {});
    },
  },
};
</script>
<style scoped>
.container {
  width: 100%;
  height: 100%;
  color: #333;
  font-size: 1.3rem;
}
.card {
  margin-bottom: 2rem;
}
.avatar {
  width: 12rem;
  height: 12rem;
  border-radius: .4rem;
}
.box-card {
  padding: 2rem;
}
.tags {
  margin: 0 .6rem;
}
.item .label {
  color: #000;
}
</style>
<style lang="less">
.el-row {
  margin-bottom: 1.2rem;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  border-radius: .4rem;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: .4rem;
  min-height: 3.2rem;
}
.row-bg {
  padding: 1rem 0;
  background-color: #f9fafc;
}
</style>